import { render, staticRenderFns } from "./ContractDetailDialog.vue?vue&type=template&id=88405158&scoped=true&"
import script from "./ContractDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ContractDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContractDetailDialog.vue?vue&type=style&index=0&id=88405158&scoped=true&lang=css&"
import style1 from "./ContractDetailDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88405158",
  null
  
)

export default component.exports